function Error() {
  return (
    <p className="subtitle has-text-centered is-fullwidth">
      Oh no something went wrong...
    </p>
  )
}

export default Error